export default __webpack_public_path__ + "static/media/sbo-girl.3422d3e6.webp";